import { render, staticRenderFns } from "./createLinkModal.vue?vue&type=template&id=22f1a1bc&scoped=true"
import script from "./createLinkModal.vue?vue&type=script&lang=js"
export * from "./createLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1a1bc",
  null
  
)

export default component.exports